export const STORAGE_PREFIX = import.meta.env.VITE_STORAGE_PREFIX || 'avanta-enterprise-';
